import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-pointer",
  "use": "icon-icon-pointer-usage",
  "viewBox": "0 0 11.9 11.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.9 11.1\" id=\"icon-icon-pointer\"><defs><style>#icon-icon-pointer .cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>资源 6</title><g id=\"icon-icon-pointer_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-pointer_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M9.4,10a4.5,4.5,0,0,1-3.2.4H5.6l-3.8-1A1.2,1.2,0,0,1,.9,7.8a1.2,1.2,0,0,1,1.4-1l1.3.4L2.3,5,.7,2.4A1.2,1.2,0,0,1,1.1.7a1.2,1.2,0,0,1,1.7.4L4.3,3.5c0,.1.1.1.2.1l3.1-2a1.4,1.4,0,0,1,1.9.5L10.7,4a4.4,4.4,0,0,1-1.3,6\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-pointer.svg
// module id = DGDc
// module chunks = 71